import React, { useContext } from 'react';
import DealerAd from '../../DealerAd';
import { ThemeOptions } from '../../publicSession/types';
import { ThemeContext } from '../../Context';
import s from './SidebarAd.scss';
export var SidebarAd = function (props) {
    var theme = useContext(ThemeContext);
    return (React.createElement(DealerAd, { className: s['root'], realEstateId: theme === ThemeOptions.DARK
            ? '150a7c06-b63c-40d0-9d26-7ce399ee49e9'
            : '856b5f3f-b93b-40cc-b7ba-66c8221a398a' }));
};
SidebarAd.displayName = 'SidebarAd';
export default SidebarAd;
//# sourceMappingURL=SidebarAd.js.map